import { inject, Injectable } from '@angular/core';

import { SUPABASE } from '../../tokens/supabase.token';
import { AuthState } from '../auth.state';

import { SonaAuthFacade } from './auth.facade';

/**
 * A facade for the user-menu feature
 */
@Injectable({
    providedIn: 'root'
})
export class SonaAuthUserMenuFacade {

    /**
     * The user of the authenticated session
     *
     * @param state
     * @param session
     */
    public static user = AuthState.user;
    public static accessToken = AuthState.accessToken;

    private readonly _authFacade = inject(SonaAuthFacade);
    private readonly _supabase = inject(SUPABASE);
    readonly isOrganizationOwner = this._authFacade.isOrganizationOwner;

    async updateUserLanguage(language: string) {
        await this._supabase.auth.updateUser({data: { lang: language }});
    }

    /**
     * Sign out the current user
     */
    signOut() {
        return this._authFacade.signOut();
    }
}
